











import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

@Component({
    name: 'option-card',
})
export default class OptionCard extends Vue {
    @Prop({ required: true })
    image!: string;

    @Emit('click')
    click() {}
}
